function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M22.096 2.055C20.854.73 19.15 0 17.296 0c-1.386 0-2.655.43-3.771 1.28A7.645 7.645 0 0012 2.846a7.64 7.64 0 00-1.525-1.566A6.102 6.102 0 006.705 0C4.85 0 3.145.73 1.903 2.055.676 3.365 0 5.155 0 7.094c0 1.996.756 3.823 2.38 5.75 1.453 1.724 3.541 3.475 5.959 5.501.826.692 1.761 1.477 2.733 2.312.257.221.586.343.928.343.341 0 .671-.122.927-.343.972-.835 1.909-1.62 2.735-2.313 2.417-2.026 4.505-3.776 5.958-5.5C23.244 10.917 24 9.09 24 7.094c0-1.94-.676-3.73-1.904-5.039z"
});

var SvgIconHeart = function SvgIconHeart(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon icon-heart",
    width: 24,
    height: 21,
    fill: "#FFF",
    stroke: "#005FFF",
    viewBox: "0 0 24 23",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-heart.ac1c52b0.svg";
export { ForwardRef as ReactComponent };